export const CONFIG = {
  APP_NAME: 'Enchei-vos',
  APP_AUTHOR: 'Felipe Augusto',
  WHATSAPP_NUMBER: '5519991073765',
  PHONE_NUMBER: '5519991073765',
};
